import React from "react"
import { asCurrency } from "../../services/Utils"
import { Tooltip } from "../common/Tooltip"
import { formatDate, formatDateTime } from "../../services/Utils"

export class ProductUnitPrice extends React.Component {
  constructor(props) {
    super(props)
  }

  showDiscountPrice() {
    const product_unit = this.props.product_unit
    return !!product_unit.show_discount
  }

  displayPrice() {
    const product_unit = this.props.product_unit
    if ( !this.showDiscountPrice() && product_unit.original_price ) { return product_unit.original_price }

    return product_unit.final_price
  }

  displayUnitPrice() {
    const product_unit = this.props.product_unit
    if ( !this.showDiscountPrice() && product_unit.original_unit_price ) { return product_unit.original_unit_price }

    return product_unit.final_unit_price
  }

  renderOriginalUnitPrice() {
    const product_unit = this.props.product_unit
    if ( !this.showDiscountPrice() || !product_unit.original_unit_price ) { return }

    const original_unit_price = asCurrency(product_unit.original_unit_price)
    return <span className='text-strike text-muted small tabular-nums'>{ original_unit_price } </span>
  }

  renderDiscountIndicator() {
    const product_unit = this.props.product_unit
    if ( !product_unit.discount_indicator ) { return }

    return (
      <span className='badge badge-success badge-pill ml-1'>
        { product_unit.discount_indicator }
      </span>
    )
  }

  renderOriginalPrice() {
    const product_unit = this.props.product_unit
    if ( !this.showDiscountPrice() || !product_unit.original_price ) { return }

    const original_price = asCurrency(product_unit.original_price)
    return (
      [
        <span className='text-strike text-muted small tabular-nums'>{ original_price }</span>,
        <span id={"discount-circle-" + product_unit.product_unit_id} className="fa fa-sm fa-info-circle ml-1 text-dark"></span>,
        <Tooltip placement="bottom" target={"discount-circle-" + product_unit.product_unit_id}>
          { product_unit.discount_description }
        </Tooltip>
      ]
    )
  }

  renderCatchWeight() {
    const product_unit = this.props.product_unit
    const unit = product_unit.catch_weight_unit == 'pound' ? 'lb' : product_unit.catch_weight_unit
    const formattedFinalPrice = asCurrency(this.displayPrice())
    return (
      <span>
        { this.renderOriginalUnitPrice() }
        <span className='tabular-nums'>{ asCurrency(this.displayUnitPrice()) }</span>
        <span> / { unit }</span>
        <span id={"info-circle-" + product_unit.product_unit_id} className="fa fa-sm fa-info-circle ml-1 text-dark"></span>
        <Tooltip placement="bottom" target={"info-circle-" + product_unit.product_unit_id}>
          { 'Est. ' }
          <span className='tabular-nums'>{ formattedFinalPrice }</span>
          { ' total. Actual size and price on final invoice.' }
        </Tooltip>
      </span>
    )
  }

  render() {
    if (!this.props.showPricing) { return '' }

    const product_unit = this.props.product_unit

    if (!product_unit.final_unit_price) {
      return (
        <span>
          { this.renderOriginalPrice() }
          { ' ' }
          <span className='tabular-nums'>{ asCurrency(this.displayPrice()) }</span>
          { this.renderDiscountIndicator() }
        </span>
      )
    } else {
      return (
        <span>
          { this.renderCatchWeight() }
          { this.renderDiscountIndicator() }
        </span>
      )
    }
  }
}
